module.exports = __webpack_public_path__ + "build/assets/TruenoRgIt-9d12e045a4b3c3b0ceeb7502aa28c306.woff";